import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { ConfigManagerSyncService } from './sync.service';
import { NotificationMessageService } from '@app/shared/notification-message/notification-message.service';

@Injectable({
  providedIn: 'root',
})
export class GoogleSheetsFeatureGuard implements CanActivate {
  constructor(
    private syncService: ConfigManagerSyncService,
    private router: Router,
    private message: NotificationMessageService,
  ) {}

  canActivate(): boolean {
    const hasGoogleLinkFeature =
      this.syncService.getProjectFeatures().googleLinkEnabled;

    if (!hasGoogleLinkFeature) {
      this.message.open({
        type: 'error',
        text: 'Google Sheets functionality is not available for this project.',
      });
      this.router.navigate(['/config-manager/branch']);
      return false;
    }

    return true;
  }
}
